import { render } from "./ValidationErrors.vue?vue&type=template&id=0c7fc76e&scoped=true"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"

import "./ValidationErrors.vue?vue&type=style&index=0&id=0c7fc76e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7fc76e"]])

export default __exports__